// ============================================
// FILE: src/components/fashion/QuickCheckoutButton.jsx
// ============================================
//
// The floating "Checkout Now" pill from the home screen, so a shopper who has
// already filled a basket can pay from wherever they are instead of navigating
// back to the cart.
//
// Renders nothing when the basket is empty or when the host screen did not
// supply an openCheckout handler, so it can be dropped into a screen that has
// no cart context without breaking it.

import React from 'react';
import { ShoppingCart } from 'lucide-react';

const QuickCheckoutButton = ({
  cart = [],
  getCartCount,
  getCartTotal,
  openCheckout,
  // Mobile PDPs pin an Add-to-Cart bar to the bottom edge, so the pill sits
  // above it; screens without one pass a smaller offset.
  bottomOffset = 'bottom-24',
}) => {
  if (typeof openCheckout !== 'function') return null;

  const count = typeof getCartCount === 'function'
    ? getCartCount()
    : (Array.isArray(cart) ? cart.reduce((n, i) => n + (i.quantity || 0), 0) : 0);

  if (!count) return null;

  const total = typeof getCartTotal === 'function'
    ? getCartTotal()
    : (Array.isArray(cart) ? cart : []).reduce((sum, item) => {
        const price = (item.sale_price && item.sale_price < item.price) ? item.sale_price : item.price;
        return sum + (Number(price) || 0) * (item.quantity || 0);
      }, 0);

  return (
    <button
      type="button"
      onClick={openCheckout}
      className={`fixed ${bottomOffset} right-4 lg:right-6 z-[310] flex items-center gap-3 px-5 py-3 text-white shadow-2xl transition-transform hover:scale-105`}
      style={{ background: 'var(--fx-pink)', borderRadius: 9999 }}
      aria-label={`Checkout ${count} ${count === 1 ? 'item' : 'items'}, total ₹${total}`}
    >
      <ShoppingCart size={20} />
      <span className="flex flex-col items-start leading-tight">
        <span style={{ fontSize: 11, fontWeight: 600, opacity: 0.9 }}>Checkout Now</span>
        <span style={{ fontSize: 15, fontWeight: 700 }}>
          {count} {count === 1 ? 'item' : 'items'} · ₹{total}
        </span>
      </span>
    </button>
  );
};

export default QuickCheckoutButton;
